import { useAuth } from '../context/AuthContext';

// Phase 39.17 — Teacher avatar globally disabled per user request.
// Returning always-hidden state keeps every lab file compiling
// without touching each consumer.
export function useTeacherAvatar(_labId) {
  const { user } = useAuth();
  return {
    showTeacher: false,
    dismissed: true,
    dismiss: () => {},
    resummon: () => {},
    avatarId: user?.avatar_id || 'male-1',
  };
}
